import React from 'react'
import NewFormDialogModel from '../../formsSystem/NewFormDialogModel'
import { Tooltip } from '@mui/material'
import WindowProps from '../../windowViewer/WindowProps'
import withStyles from '@mui/styles/withStyles'
import AddToBoardDialogContent from './AddToBoardComps/AddToBoardDialogContent'
import { SiReacttable } from 'react-icons/si'
import i18next from 'i18next'

const styles = () => ({
  icon: {
    cursor: 'pointer',
    fontSize: 18,
    '&:hover': {
      opacity: 0.8,
    },
  },
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
  },
})

const AddToBoard = ({ classes, noFSPanelProps }) => {
  const { showAddToBoard } = noFSPanelProps
  const { isWindowOpen, windowOpener, windowCloser } = WindowProps()
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <>
      <Tooltip title={rtl ? 'إضافة الى مجلي الإدارة' : 'Add to Board Members'}>
        <span
          className={classes.iconWrapper}
          style={{ display: showAddToBoard ? null : 'none' }}
          onClick={() => windowOpener()}
        >
          <SiReacttable className={classes.icon} />
        </span>
      </Tooltip>
      <NewFormDialogModel
        NewFormComponent={
          <AddToBoardDialogContent
            noFSPanelProps={noFSPanelProps}
            windowCloser={windowCloser}
          />
        }
        newFormDialogClose={windowCloser}
        isNewFormDialogOpen={isWindowOpen}
        {...noFSPanelProps}
        clickAwayState={true}
        dialogTitle={rtl ? 'إضافة الى مجلي الإدارة' : 'Add to Board Members'}
      />
    </>
  )
}

const WrappedAddToBoard = withStyles(styles)(AddToBoard)

export default WrappedAddToBoard
